import Portfolio2 from './Portfolio2'
export default Portfolio2
